export default __webpack_public_path__ + "media/components/blocks/ProUpsell/logo_pro-7fdc532cfc806d8240de8fad7caa7f5a.png";